module.exports = __webpack_public_path__ + "assets/1792649897182/img/start-icon.a1db7227.png";